// Central content store — swap values here when official assets/copy arrive.

export const BUSINESS = {
  name: "Roma's Café Diner",
  shortName: "Roma's",
  descriptor: "Café · Diner — Lanka, Varanasi",
  addressLines: [
    "24, 2nd Floor, Swastik Plaza",
    "Near Ravidas Gate, Lanka",
    "Varanasi, Uttar Pradesh 221005, India",
  ],
  phones: [
    { label: "+91 99844 44095", href: "tel:+919984444095" },
    { label: "+91 542 236 6138", href: "tel:+915422366138" },
  ],
  email: "romascafediner@gmail.com",
  instagramHandle: "@romascafediner",
  instagramUrl: "https://www.instagram.com/romascafediner/",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Roma%27s+Caf%C3%A9+Diner+Swastik+Plaza+Ravidas+Gate+Lanka+Varanasi",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1739723745132-97df9db49db2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHx2aWJyYW50JTIwYXJ0aXNhbmFsJTIwY2FmZSUyMGRpbmVyJTIwaW50ZXJpb3IlMjB3YXJtJTIwYmlnaHRpbmd8ZW58MHx8fHwxNzkwODI1MzA5fDA&ixlib=rb-4.1.0&q=85",
  interior:
    "https://images.unsplash.com/photo-1583354608715-177553a4035e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHx2aWJyYW50JTIwYXJ0aXNhbmFsJTIwY2FmZSUyMGRpbmVyJTIwaW50ZXJpb3IlMjB3YXJtJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkwODI1MzA5fDA&ixlib=rb-4.1.0&q=85",
  lights:
    "https://images.unsplash.com/photo-1729394404917-21d9e73e5454?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHx2aWJyYW50JTIwYXJ0aXNhbmFsJTIwY2FmZSUyMGRpbmVyJTIwaW50ZXJpb3IlMjB3YXJtJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkwODI1MzA5fDA&ixlib=rb-4.1.0&q=85",
  dish1: "https://images.unsplash.com/photo-1669472546359-418a98630699?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxnb3VybWV0JTIwYXJ0aXNhbmFsJTIwY2FmZSUyMGZvb2QlMjBnb3VybWV0JTIwZGlzaCUyMHBsYXRlfGVufDB8fHx8MTc5MDgyNTMxMnww&ixlib=rb-4.1.0&q=85",
  dish2: "https://images.unsplash.com/photo-1514326640560-7d063ef2aed5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxnb3VybWV0JTIwYXJ0aXNhbmFsJTIwY2FmZSUyMGZvb2QlMjBnb3VybWV0JTIwZGlzaCUyMHBsYXRlfGVufDB8fHx8MTc5MDgyNTMxMnww&ixlib=rb-4.1.0&q=85",
  dish3: "https://images.unsplash.com/photo-1600663791817-d74f5196ba29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxnb3VybWV0JTIwYXJ0aXNhbmFsJTIwY2FmZSUyMGZvb2QlMjBnb3VybWV0JTIwZGlzaCUyMHBsYXRlfGVufDB8fHx8MTc5MDgyNTMxMnww&ixlib=rb-4.1.0&q=85",
  dish4: "https://images.unsplash.com/photo-1631303494240-7c3bc6bd8c03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxnb3VybWV0JTIwYXJ0aXNhbmFsJTIwY2FmZSUyMGZvb2QlMjBnb3VybWV0JTIwZGlzaCUyMHBsYXRlfGVufDB8fHx8MTc5MDgyNTMxMnww&ixlib=rb-4.1.0&q=85",
};

export const img = (url, w = 1200) => `${url}&w=${w}&auto=format`;

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Our Story", id: "story" },
  { label: "Menu", id: "menu" },
  { label: "Experience", id: "experience" },
  { label: "Gallery", id: "gallery" },
  { label: "Events", id: "events" },
  { label: "Contact", id: "contact" },
];

// Menu examples — illustrative dishes, neutral descriptions, no prices.
export const MENU_NOTE =
  "Menu examples — dishes shown to illustrate the style of the kitchen. Availability and prices are shared at the diner.";

export const MENU_CATEGORIES = [
  {
    id: "small-plates",
    label: "Small Plates",
    dishes: [
      {
        name: "Bruschetta al Pomodoro",
        description: "Grilled bread with tomato, basil and a slow pour of olive oil.",
        image: "dish1",
      },
      {
        name: "Spiced Fries, House Dip",
        description: "Crisp fries dusted with a warm spice blend, served with a creamy dip.",
        image: "dish2",
      },
      {
        name: "Soup of the Evening",
        description: "A rotating bowl, built around whatever the season offers.",
        image: "dish3",
      },
    ],
  },
  {
    id: "diner-plates",
    label: "Diner Plates",
    dishes: [
      {
        name: "The Diner Stack",
        description: "A layered vegetarian burger with house slaw and pickled onion.",
        image: "dish4",
      },
      {
        name: "Creamy Pesto Pasta",
        description: "Pasta folded through a basil-cashew pesto, finished with parmesan.",
        image: "dish2",
      },
      {
        name: "Roma's Grilled Platter",
        description: "A generous grilled plate with seasonal vegetables and flatbread.",
        image: "dish1",
      },
    ],
  },
  {
    id: "coffee-brews",
    label: "Coffee & Brews",
    dishes: [
      {
        name: "Slow Brew Coffee",
        description: "A carefully brewed cup — black, or softened with milk.",
        image: "dish3",
      },
      {
        name: "Café Mocha",
        description: "Espresso rounded with chocolate and steamed milk.",
        image: "dish4",
      },
      {
        name: "Iced Vietnamese-Style",
        description: "Strong coffee over ice with a sweet, creamy finish.",
        image: "dish1",
      },
    ],
  },
  {
    id: "sweet-finish",
    label: "A Sweet Finish",
    dishes: [
      {
        name: "Tiramisu, Café Style",
        description: "Coffee-soaked layers beneath a light mascarpone cream.",
        image: "dish4",
      },
      {
        name: "Warm Chocolate Brownie",
        description: "Served warm — ask about the day's pairing at the counter.",
        image: "dish2",
      },
      {
        name: "Basque-Style Cheesecake",
        description: "A caramelised top over a soft, creamy centre.",
        image: "dish3",
      },
    ],
  },
];

export const MARQUEE_ITEMS = [
  "Espresso & Conversation",
  "Vintage Vinyl",
  "Warm Lamplight",
  "Slow Mornings",
  "From the Griddle",
  "Lanka · Varanasi",
];

export const GALLERY_ITEMS = [
  { image: "interior", caption: "The corner table, late afternoon", alt: "Warm café interior with wooden tables and soft light" },
  { image: "dish1", caption: "Plated, simply", alt: "An artfully plated gourmet café dish" },
  { image: "lights", caption: "Evening light, low and warm", alt: "Café interior glowing with warm evening lights" },
  { image: "dish2", caption: "From the kitchen pass", alt: "A gourmet café plate served on a dark table" },
  { image: "dish3", caption: "A slow course", alt: "A carefully presented artisanal dish" },
  { image: "dish4", caption: "Sweet endings", alt: "A dessert plate styled with care" },
];
